/**
 * Action for Fetch connector list details
 */
export enum getConnectorServiceDesc {
  FETCH_CONNECTOR_SERVICE_DESC_REQUEST = 'FETCH_CONNECTOR_SERVICE_DESC_REQUEST',
}
